import apiClient from 'utilities/apiClient';

// get_Countrycodes
export const payment = (payload) => {
  return apiClient.post(`${apiClient.Urls.paymentdata}`, payload, true);
};

// paymentverify
export const paymentverify = (payload) => {
  return apiClient.post(`${apiClient.Urls.paymentverify}`, payload, true);
};
